<template>
  <div class="detail-page">
    <!-- <van-overlay :show="generating">
      <van-loading type="spinner" color="#fff" />
    </van-overlay> -->
	<van-overlay :show="generating">
		<div style="position: absolute;width: 100%;top: 45%;left: 0;">
			<div class="upload-overlay">
				<van-loading type="spinner" color="#fff" />
			</div>
		</div>
	</van-overlay>
    <div class="detail-bg">
      <div class="detail-top">
        <img src="../assets/new/detail_banner.png" class="detail-bg-img" />
      </div>

      <div class="detail-content">
        <div class="detail-card">
          <div class="detail-title">
            <img src="@/assets/new/detail_icon.png" class="detail-icon" />
            <span class="title-text">{{ detail.option_title }}</span>
			<div v-if="voteStartsign === 'yes'" class="vote-count">
				<span>{{ detail.option_vnum }}</span>
				<span style="color: #fff;margin-left: 3px;">票</span>
			</div>
          </div>
          <div class="detail-media">
            <video
              v-if="isVideo"
              ref="videoPlayer"
              controls
              :poster="detail.option_pic"
              class="video-player"
              webkit-playsinline
              playsinline
              x5-video-player-type="h5-page"
            >
              <source :src="detail.option_url" type="video/mp4" />
            </video>
            <div v-if="isImage" style="text-align: center;">
				<div style="color: #fff;padding-bottom: 10px;">(点击下方图片查看详情)</div>
				<a :href="detail.option_url" target="_blank">
					<img :src="detail.option_pic" style="width: 100%;border-radius: 15px;" />
				</a>
				
			</div>
			<audio v-if="isAudio" :src="detail.option_url" controls style="width: 100%;"></audio>
          </div>
          <div class="detail-desc">{{ detail.option_alt }}</div>
          <div v-if="voteStartsign === 'yes'" class="detail-actions" align="center">
            <img src="@/assets/new/detail_vote_btn.png" class="detail-vote-btn" @click="handleVote" />
            <img src="@/assets/new/lapiao.png" class="detail-back-btn" @click="generatePoster" />
          </div>
          <div class="detail-actions" align="center">
            <img src="@/assets/new/detail_back_btn.png" class="detail-back-btn" @click="goBack" />
          </div>
        </div>
      </div>
    </div>

    <div v-if="showPoster" style="position: fixed;height: 100vh;width: 100vw;top: 0;left: 0;overflow-y: auto;">
      
	  <div style="padding-bottom: 30px;position: relative;min-height: 100vh;">
		  <div @click="showPoster = false" style="position: absolute;top: 0;left: 0;width: 100%;height: 100%;background-color: rgba(0, 0, 0, 0.7);">
		  		  
		  </div>
		  <div style="width: 80%;text-align: center;margin: 0 auto;position: relative;">
			  <div class="poster-tip" @click="showPoster = false">长按保存图片，发给好友一起参与</div>
			  <img :src="posterImage" @click.stop style="width: 100%;" />
		  </div>
        
      </div>
    </div>

    <div style="position: fixed; left: 120%; top: 0; width: 100%;">
      <div id="sharediv" ref="shareDiv" style="width: 80%;">
        <div class="share-card">
          <div class="detail-top">
            <img src="../assets/new/detail_banner.png" class="detail-bg-img" style="padding: 20px 15px 15px;" />
          </div>
          <div class="share-content">
            <img :src="detail.option_pic" style="width: 100%;" />
            <div class="share-text">{{ detail.option_num }}号作品"{{ detail.option_title }}"，快来为作品点赞吧！</div>
            <div class="share-qr">
              <img :src="detail.option_ewmurl" style="width: 30%;" />
            </div>
            <div class="share-qr-tip">长按识别二维码<br />为TA点赞</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Toast from 'vant/lib/toast'
import 'vant/lib/toast/style';
import html2canvas from 'html2canvas'
import { getVoteDetail, submitVote } from '@/api'
import { isJiyun, getFileType } from '@/utils'

export default {
  name: 'Detail',
  props: {
	  voteStartsign: {
      type: String,
      default: 'no'
    },
    optionId: {
      type: [String, Number],
      default: ''
    },
    voteid: {
      type: [String, Number],
      default: null
    },
    wxopenid: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      detail: {},
      isVideo: false,
	  isImage: false,
	  isAudio: false,
      generating: false,
      showPoster: false,
      posterImage: '',
      sxflag: false
    }
  },
  watch: {
    optionId: {
      handler(val) {
        if (val) {
          this.detail = {}
          this.isVideo = false
          this.showPoster = false
          this.posterImage = ''
          this.sxflag = false
          this.fetchDetail()
        }
      },
      immediate: true
    }
  },
  methods: {
    fetchDetail() {
      if (!this.optionId) return
      getVoteDetail({ option_id: this.optionId }).then(res => {
        var data = typeof res.data === 'string' ? JSON.parse(res.data) : res.data
        if (data && data.data) {
          this.detail = data.data
		  console.log("this.detail:",this.detail)
          var fileType = getFileType(this.detail.option_url || '')
          this.isVideo = fileType === 'mp4' || fileType === 'MP4'
		  this.isAudio = fileType === 'mp3' || fileType === 'MP3'
		  if(!this.isVideo&&!this.isAudio){
			  this.isImage = true
		  }
		  console.log("this.detail2:",this.detail)
		  
        }
        window.scroll(0, 0)
      }).catch(function(err) {
        console.error('fetchDetail error:', err)
        Toast('获取详情失败')
      })
    },
    handleVote() {
      if (isJiyun()) {
        Toast('请分享到微信客户端内打开链接参与投票')
        return
      }
      if (this.sxflag) {
        Toast('您今天已达投票上限')
        return
      }
      try {
        var captcha = new TencentCaptcha('190326154', this.onCaptchaCallback, {
          userLanguage: 'zh-cn'
        })
        captcha.show()
      } catch (error) {
        this.loadErrorCallback()
      }
    },
    onCaptchaCallback(res) {
      if (res.ret === 0) {
        var params = {
          Ticket: res.ticket,
          Randstr: res.randstr,
          wxopenid: this.wxopenid,
          option_id: this.optionId,
          option_voteid: this.voteid
        }
        submitVote(params).then(response => {
          var data = typeof response.data === 'string' ? JSON.parse(response.data) : response.data
          if (data.code == 1) {
            this.detail.option_vnum = parseInt(this.detail.option_vnum) + 1
            this.$emit('voted', this.optionId)
            Toast('投票成功')
          } else {
            Toast(data.msg || '投票失败')
            if (data.msg && data.msg.indexOf('上限') > -1) {
              this.sxflag = true
              this.$emit('vote-limit')
            }
          }
        })
      }
    },
    loadErrorCallback() {
      var appid = '190326154'
      var ticket = 'trerror_1001_' + appid + '_' + Math.floor(new Date().getTime() / 1000)
      this.onCaptchaCallback({
        ret: 0,
        randstr: '@' + Math.random().toString(36).substr(2),
        ticket: ticket,
        errorCode: 1001,
        errorMessage: 'jsload_error'
      })
    },
    generatePoster() {
      this.generating = true
      this.$nextTick(() => {
        var domElement = this.$refs.shareDiv
        if (!domElement) {
          this.generating = false
          return
        }
        html2canvas(domElement, {
          dpi: 300,
          scale: 1,
          width: domElement.offsetWidth,
          height: domElement.offsetHeight,
          useCORS: true,
          async: false
        }).then(canvas => {
          var context = canvas.getContext('2d')
          context.mozImageSmoothingEnabled = false
          context.webkitImageSmoothingEnabled = false
          context.msImageSmoothingEnabled = false
          context.imageSmoothingEnabled = false
          this.posterImage = canvas.toDataURL('jpg/jpeg', 1.0)
          this.generating = false
          this.showPoster = true
          window.scroll(0, 0)
        }).catch(() => {
          this.generating = false
          Toast('生成海报失败')
        })
      })
    },
    goBack() {
      this.$emit('back')
    }
  }
}
</script>

<style scoped>
.detail-page {
  min-height: 100vh;
}
.detail-bg {
  background-image: url(../assets/new/detail_bg.jpg);
  background-size: 100% 100%;
  min-height: 100vh;
  padding-bottom: 30px;
}
.detail-top {
  position: relative;
  width: 100%;
  text-align: right;
}
.detail-bg-img {
  width: 60%;
  padding: 40px 15px 30px;
}
.detail-content {
  padding: 0px 15px 30px;
  position: relative;
  box-sizing: border-box;
}
.detail-card {
  box-sizing: border-box;
  padding: 30px 20px;
  width: 100%;
  margin: 0 auto;
  background-image: url('@/assets/new/detail_card.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  border-radius: 20px;
}
.detail-title {
  font-size: 1.1rem;
  color: #fff;
  text-align: left;
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  flex-wrap: wrap;
}
.detail-icon {
  width: 32px;
  height: 32px;
  margin-right: 10px;
}
.title-text {
  flex: 1;
  font-weight: bold;
  font-size: 1.5rem;
}
.vote-count {
  color: #ffd700;
  font-weight: bold;
  font-size: 1.5rem;
}
.detail-media {
  width: 100%;
  position: relative;
  margin-top: 15px;
  border-radius: 15px;
  overflow: hidden;
}
.video-player {
  width: 100%;
  height: 200px;
  outline: none;
}
.detail-desc {
  margin-top: 10px;
  font-size: 1.1rem;
  color: #fff;
  line-height: 1.6;
}
.detail-actions {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}
.detail-vote-btn {
  width: 40%;
  cursor: pointer;
  touch-action: manipulation;
 
}
.detail-back-btn {
  width: 40%;
  cursor: pointer;
  touch-action: manipulation;
  
}
.poster-overlay {
  
  width: 100%;
  height: 100vh;
  overflow-y: auto;
  text-align: center;
}
.poster-tip {
  color: #fff;
  font-size: 0.9rem;
  padding-bottom: 8px;
  padding-top: 50px;
}
.share-card {
  background-image: url('@/assets/new/detail_bg.jpg');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  padding-bottom: 10px;
}
.share-banner {
  text-align: center;
  font-size: 0;
  padding: 20px 0 10px;
}
.share-content {
  padding: 15px 4% 10px;
  background-color: #faffeb;
  width: 82%;
  border-radius: 6px;
  margin: 0 auto;
}
.share-text {
  font-size: 1rem;
  margin-top: 10px;
}
.share-qr {
  margin-top: 20px;
  font-size: 0;
}
.share-qr-tip {
  font-size: 0.8rem;
  line-height: 1rem;
  margin-top: 3px;
}

.upload-overlay {
	display: flex;
	flex-direction: column;
	align-items: center;
}
</style>
